const PHONE_HREF = 'tel:+905362771709';
const WA_HREF = 'https://wa.me/905362771709';

const features = [
  {
    num: '01',
    title: 'Ücretsiz Keşif Hizmeti',
    desc: 'Yerinde ölçüm ve danışmanlık tamamen ücretsiz. Ekibimiz gelir, ihtiyacınızı değerlendirir, en uygun çözümü önerir.',
  },
  {
    num: '02',
    title: 'Dayanıklı Malzeme Kalitesi',
    desc: 'Ege iklimine uygun, UV dayanımlı, tuz havasına karşı test edilmiş alüminyum ve kumaş malzemeler kullanıyoruz.',
  },
  {
    num: '03',
    title: 'Uzman Montaj Ekibi',
    desc: '15 yılı aşkın deneyimiyle her projeyi titizlikle tamamlayan, sertifikalı montaj ekibimiz hizmetinizde.',
  },
  {
    num: '04',
    title: 'Uygun Fiyat Politikası',
    desc: 'Kaliteden ödün vermeden rekabetçi fiyatlar. Şeffaf teklif, gizli maliyet yok.',
  },
  {
    num: '05',
    title: 'Hızlı Kurulum',
    desc: 'Anlaşma sonrası kısa sürede montaj. Terası ya da bahçenizi bekletmiyoruz.',
  },
  {
    num: '06',
    title: 'Geniş Hizmet Bölgesi',
    desc: 'Alaçatı, Çeşme, Ilıca, Ovacık, Dalyan ve Reisdere\'de aktif hizmet.',
  },
];

export default function WhyUsSection() {
  return (
    <section className="py-24 bg-[#111827]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          {/* Left sticky */}
          <div className="lg:col-span-2 lg:sticky lg:top-24">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-[#D4A853]"></span>
              <span className="text-[#D4A853] text-xs font-bold tracking-widest uppercase">Neden Biz?</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              Neden<br />Alaçatı<br />Tenteci?
            </h2>
            <p className="text-white/50 text-sm leading-relaxed mb-8">
              Alaçatı&apos;nın güneşini ve meltemini kontrol altına almanın en akıllı yolu — doğru malzeme, doğru ekip, doğru fiyat. 500&apos;den fazla tamamlanan proje bizi anlatıyor.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href={PHONE_HREF}
                className="flex items-center gap-2 bg-[#D4A853] text-[#111827] font-bold text-xs tracking-widest uppercase px-6 py-4 whitespace-nowrap cursor-pointer hover:bg-[#c49840] transition-colors"
              >
                <i className="ri-phone-line"></i>
                Ücretsiz Keşif İçin Ara
              </a>
              <a
                href={WA_HREF}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-2 border border-white/20 text-white font-bold text-xs tracking-widest uppercase px-6 py-4 whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors"
              >
                <i className="ri-whatsapp-line"></i>
                Hızlı Teklif İçin WhatsApp
              </a>
            </div>
          </div>

          {/* Right: Features */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/5">
            {features.map((f) => (
              <div key={f.num} className="bg-[#111827] p-7 border border-white/5 hover:border-[#D4A853]/30 transition-colors group">
                <span className="text-[#D4A853]/30 text-4xl font-black leading-none block mb-4 group-hover:text-[#D4A853]/60 transition-colors">{f.num}</span>
                <h3 className="text-white font-bold text-sm mb-2">{f.title}</h3>
                <p className="text-white/40 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
